import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import {
  INITIAL_OFFSHORE_REPORTS_STATE,
  OFFSHORE_REPORTS_STORE_ID,
  ReducedOffshoreReport,
} from '@navstation-portal/reporting/data-model/offshore-reports';
import { signalStore, withComputed, withHooks, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { injectDispatch } from '@ngrx/signals/events';
import { offshoreReportsEvents } from './offshore-reports-events';
import { buildOffshoreReportsVm } from './offshore-reports-vm-builder';
import { withOffshoreReportsEffects } from './with-offshore-reports-effects';
import { withOffshoreReportsReducer } from './with-offshore-reports-reducer';

export const OffshoreReportsStore = signalStore(
  { providedIn: 'root' },
  withDevtools(OFFSHORE_REPORTS_STORE_ID, withGlitchTracking()),
  withState(INITIAL_OFFSHORE_REPORTS_STATE),
  withEntities<ReducedOffshoreReport>(),
  withOffshoreReportsEffects(),
  withOffshoreReportsReducer(),
  withComputed((store) => ({
    vm: computed(() => {
      const reports = store.entities();
      return buildOffshoreReportsVm(reports);
    }),
  })),
  withHooks(() => {
    const offshoreReportsDispatch = injectDispatch(offshoreReportsEvents);
    return {
      onInit: () => {
        offshoreReportsDispatch.fetchReports('');
      },
    };
  })
);
